import { motion } from "framer-motion";
export default () => {
  return (
    <motion.span
      className="font-bold text-2xl"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      nett<span className="text-primary">pay</span>
    </motion.span>
  );
};
